export default {"src":"/_next/static/media/right.cba1dde0.svg","height":232,"width":83};